<template>
    <a class="nav-content-preview u-reset link link__element" :href="link.path">
        <picture-element class="nav-content-preview--image" v-bind="image"/>
        <h3 class="nav-content-preview--title">{{ title }}</h3>
        <p class="u-reset nav-content-preview--description">{{ description }}</p>
        <span class="u-reset link link__icon">
            <span class="link--label">{{ link.label }}</span>
            <base-icon class="link--icon" symbol="arrow-right" size="small"/>
        </span>
    </a>
</template>

<script>
    import PictureElement from 'framework/global-components/dyn/picture-element/picture-element';
    import IconLink from 'framework/components/icon-link/icon-link';

    export default {
        components: { IconLink, PictureElement },
        props: {
            /** @type {ISvgImageSet} */
            image: {
                type: Object,
                required: true,
            },

            title: {
                type: String,
                required: true,
            },

            description: {
                type: String,
                required: true,
            },

            /** @type {ILink} */
            link: {
                type: Object,
                required: true,
            },
        },
    };
</script>
